<template>
  <el-drawer
    :title="title"
    :visible.sync="visible"
    :direction="direction"
    :before-close="handleClose"
    :size="size"
  >
    <template v-if="data.type === 'table'">
      <Body
        :headConfig="data.headConfig"
        :tableData="data.content"
        @callback1="data.callback1"
        @callback2="data.callback2"
        v-loading="isLoading"
      />
    </template>
  </el-drawer>
</template>

<script>
import Body from "@/components/Table/Body";

export default {
  props: {
    title: {
      type: String,
      default: "详细信息",
    },
    size: {
      type: String,
      default: "50%",
    },
    direction: {
      type: String,
      default: "rtl",
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  components: {
    Body,
  },
  methods: {
    show() {
      this.visible = !this.visible;
    },
    handleClose(done) {
      this.$confirm("是否关闭留言信息?", "操作提示")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
  },
};
</script>

<style></style>
